export default __webpack_public_path__ + "static/media/02.bd59689e.jpg";